var sensors = require('sa-sdk-javascript');

sensors.init({
  server_url: 'https://scdata.ucloudlink.com/sa?project=GLocalMe_IOT',
  is_track_single_page:false, // 单页面配置，默认关闭。开启后自动监听 URL 有变化就会触发 $pageview 事件
  use_client_time:true, 
  send_type:'beacon',
  show_log: false, // 是否在控制台打印日志，默认关闭
  heatmap: {
     //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
     clickmap:'default',
     //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
     scroll_notice_map:'default',
     web_stay_delay: 10000,         // 停留超过 10 秒触发上报
  }
});

let urlData = JSON.parse( sessionStorage.getItem('urlData') || '{}');

sensors.registerPage({
  $app_name: 'H5',
  platform_type: "H5",
  imei: urlData.imei,
  mvno_code: urlData.mvnoCode,
  projectConfig: urlData.mvnoCode,
  is_login:JSON.parse(sessionStorage.getItem("loginStatus") || 'false'),
  operate_country: urlData.registerCountry || urlData.placeCode,
  user_account: urlData.username,
});


// sensors.quick('autoTrack'); //用于采集 $pageview 事件。

export default sensors; //导出sensors对象